<template>
  <div class="page">
    <div class="pl20 pt10 pb10 bg_white mt20">成为vip客户</div>

    <el-tabs class="mt20 bg_white" v-model="tab" type="border-card">
      <el-tab-pane label="基础信息" name="1">
        <div class="form mt50" style="margin-left: 210px">
          <el-form label-width="80px">
            <el-form-item label="公司名称">
              <el-input v-model="submit_form.company_name" class="input"></el-input>
            </el-form-item>
            <el-form-item label="公司地址">
              <el-cascader
                v-if="address.length!=0"
                :props="cascader_props"
                class="input"
                size="large"
                v-model="address"
                :options="region_data"
              />
              <select-address-cascader v-model="address"/>

              <div class="mt20">
                <el-input
                  v-model="submit_form.company_address"
                  rows="4"
                  class="input"
                  placeholder="详细地址"
                  type="textarea"
                ></el-input>
              </div>
            </el-form-item>

            <el-form-item label="公司电话">
              <el-input v-model="submit_form.company_tel" class="input"></el-input>
            </el-form-item>

            <el-form-item label="联系人">
              <el-input v-model="submit_form.contact_name" class="input"></el-input>
            </el-form-item>

            <el-form-item label="联系人电话">
              <el-input v-model="submit_form.contact_mobile" class="input"></el-input>
            </el-form-item>

            <el-form-item label="联系人岗位">
              <el-input v-model="submit_form.contact_position" class="input"></el-input>
            </el-form-item>

            <el-form-item label="公司统一社会信用代码">
              <el-input v-model="submit_form.company_taxno" class="input"></el-input>
            </el-form-item>

            <el-form-item label="开户银行">
              <el-input v-model="submit_form.company_bank_name" class="input"></el-input>
            </el-form-item>
            <el-form-item label="银行卡号">
              <el-input v-model="submit_form.company_bank_no" class="input"></el-input>
            </el-form-item>

            <el-form-item label>
              <div style="color: #E63212">注：以上信息均为必填信息。如实填写有助于更快通过审核。</div>
            </el-form-item>
          </el-form>
        </div>

        <div class="fr jc ac mb50 mt50">
          <el-button style="width: 315px" type="primary" @click="next">下一步</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="资质信息" name="2">
        <div style="margin-left: 210px">
          <el-form label-width="80px">
            <el-form-item label="公司logo:">
              <upload-img :file_list.sync="submit_form.company_logo" :limit="1"></upload-img>
            </el-form-item>
          </el-form>

          <el-form label-width="80px">
            <el-form-item label="其他证照:">
              <div style="color: #666666">图片仅支持.jpeg、.png格式</div>
              <upload-img :file_list.sync="submit_form.company_certificate_imgs" :limit="5"></upload-img>
            </el-form-item>
          </el-form>

          <el-form label-width="80px">
            <el-form-item label>
              <span style="color: #E63212">注：以上信息均为必填信息。如实填写有助于更快通过审核。</span>
            </el-form-item>
          </el-form>
        </div>
        <div class="fr jc ac" style="margin-bottom: 80px;margin-top: 100px">
          <el-button type="primary" style="width: 315px" @click="submit">提交</el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import UploadImg from "../../components/UploadImg";

export default {
  data() {
    return {
      is_count_down: false,
      count_down: 60,
      //协议弹窗
      protocol_show: false,
      tab: "1",

      //北京市 / 市辖区 / 西城区
      address: [],
      //提交表单信息
      submit_form: {
        company_name: "",
        company_logo: [],
        company_province: "",
        company_city: "",
        company_country: "",
        company_address: "",
        company_tel: "",
        company_taxno: "",
        company_bank_name: "",
        company_bank_no: "",
        contact_name: "",
        contact_mobile: "",
        contact_position: "",
        company_certificate_imgs: [],
        company_remark: "",
      },
    };
  },
  mounted() {
    this.getCompanyDetail();
  },
  methods: {
    //获取公司详情
    getCompanyDetail() {
      let param = {};
      this.post("companyInterfaces/v1.0/getCompanyDetail", param).then(
        (res) => {
          this.submit_form = res.data;
          this.address[0] = this.submit_form.company_province;
          this.address[1] = this.submit_form.company_city;
          this.address[2] = this.submit_form.company_country;
          console.log(this.address);
          this.submit_form.company_logo = this.submit_form.company_logo.split(
            ","
          );
          this.submit_form.company_certificate_imgs = this.submit_form.company_certificate_imgs.split(
            ","
          );
        }
      );
    },
    //    下一步

    next() {
      if (!this.submit_form.company_name) {
        this.$message("请输入公司名称");
        return;
      }
      if (this.address.length == 0) {
        this.$message("请输入公司地址");
        return;
      }
      if (!this.submit_form.company_address) {
        this.$message("请输入详细地址");
        return;
      }
      if (!this.submit_form.company_tel) {
        this.$message("请输入公司电话");
        return;
      }
      if (!this.submit_form.contact_name) {
        this.$message("请输入联系人");
        return;
      }
      if (this.submit_form.contact_mobile.length != 11) {
        this.$message("请输入正确的联系人电话");
        return;
      }
      if (!this.submit_form.contact_position) {
        this.$message("请输入联系人岗位");
        return;
      }
      if (this.submit_form.company_taxno.length != 18) {
        this.$message("公司统一社会信用代码应为18位");
        return;
      }
      if (!this.submit_form.company_bank_name) {
        this.$message("请输入开户银行");
        return;
      }
      if (!this.submit_form.company_bank_no) {
        this.$message("请输入银行卡号");
        return;
      }

      this.tab = "2";
    },

    //    提交
    submit() {
      if (!this.submit_form.company_name) {
        this.$message("请输入公司名称");
        return;
      }
      if (this.address.length == 0) {
        this.$message("请输入公司地址");
        return;
      }
      if (!this.submit_form.company_address) {
        this.$message("请输入详细地址");
        return;
      }
      if (!this.submit_form.company_tel) {
        this.$message("请输入公司电话");
        return;
      }
      if (!this.submit_form.contact_name) {
        this.$message("请输入联系人");
        return;
      }
      if (this.submit_form.contact_mobile != 11) {
        this.$message("联系人电话为11位");
        return;
      }
      if (!this.submit_form.contact_position) {
        this.$message("请输入联系人岗位");
        return;
      }
      if (this.submit_form.company_taxno != 18) {
        this.$message("公司统一社会信用代码应为18位");
        return;
      }
      if (!this.submit_form.company_bank_name) {
        this.$message("请输入开户银行");
        return;
      }
      if (!this.submit_form.company_bank_no) {
        this.$message("请输入银行卡号");
        return;
      }

      if (this.submit_form.company_logo.length == 0) {
        this.$message("请输入公司logo");
        return;
      }
      if (this.submit_form.company_certificate_imgs.length == 0) {
        this.$message("请输入公司证照");
        return;
      }

      this.confirmSubmit();
    },

    //    同意协议
    confirmSubmit() {
      let param = Object.assign({}, this.submit_form);
      param.company_province = this.address[0];
      param.company_city = this.address[1];
      param.company_country = this.address[2];

      param.company_logo = param.company_logo.join(",");
      param.company_certificate_imgs = param.company_certificate_imgs.join(",");
      this.post("companyInterfaces/v1.0/againApplyCompany", param).then(
        (res) => {
          //    去协议页面
          this.go("/protocol?html_id=3");
        }
      );
    },
  },
  components: {
    "upload-img": UploadImg,
  },
};
</script>

<style scoped lang="scss">
.page {
  width: 1200px;
  font-size: 14px;
  margin: 0 auto;
  margin-bottom: 138px;
}

.form {
  .input {
    width: 381px;
  }

  &>>> .el-form-item__label {
    width: 150px;
    white-space: nowrap;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/register/ReapplyCompany.vue